import {useEffect} from 'react';
//store
import {useSelector, useDispatch} from 'react-redux';
import actions from 'store/actions';
//types
import IStoreState from 'store/types';

export default function useAuthAlert(show: boolean) {
  const dispatch = useDispatch();
  const message = useSelector((state: IStoreState) => state.auth.alert);

  useEffect(() => {
    if (show && message) {
      setTimeout(() => {
        alert(message);
        dispatch(actions.auth.alert());
      }, 0);
    }
  }, [show, message, dispatch]);
}
